const CIRCLE_DETAILS_SUBTILE1 = "THE CIRCLE";
const CIRCLE_DETAILS_BRIEF1 =
  "THE CIRCLE is the Engagement Program of WILDCRAFT.";
const CIRCLE_DETAILS_BRIEF2 =
  "THE CIRCLE provides the consumers of WILDCRAFT a 360 degree platform where they can interact with their favourite brands, share their experiences with fellow users and the company, provide feedback and suggestions on products & services and get the latest updates on the happenings in the world of WILDCRAFT.";
const CIRCLE_DETAILS_BRIEF3 =
  "THE CIRCLE provides consumers a single window to get all the information about the brands, the products and services of WILDCRAFT.";
const CIRCLE_DETAILS_SUBTILE2 = "MEMBERSHIP PRIVILEGES";
const CIRCLE_DETAILS_LIST =
  '{"lists":[{"subpoints":[" A single window of access to WILDCRAFT for information, queries and feedback","Priority updates & processing for WILDCRAFT Product Suite"," Priority queueing and benefits on Warranty Services"," Exclusive Product & Sale Previews for members at our showrooms and website"]}]}';
const CIRCLE_DETAILS_BRIEF4 =
  "Wildcraft is a brand born for the open air! Whether it’s a hill or a mountain, the forest or the countryside, the great outdoors can invigorate you like no other and Wildcraft equips you with the means to experience it. A head–to–toe outfitter, the brand’s product portfolio includes jackets & cheaters, shoes & sandals, rucksacks & backpacks, sleeping bags and travel accessories for trekking, camping, travel and commute for the backpacker in each one of us. Wildcraft products are typically designed to work with, and not against, the elements and equip us to embrace the uncertainty of weather, terrain and the like, that we face when we go outdoors. #ReadyForAnything";
const CIRCLE_DETAILS_CONCLUSION =
  "Subscription Fee: Currently, free for lifetime.";

const MESSAGE_TRIGGER_PARAM1 = {
  templateId: "wildcraft_circle_details",
  from: "",
  subject: "Wildcraft Circle form details",
  message: "",
};

const MESSAGE_TRIGGER_PARAM2 = {
  templateId: "wildcraft_circle_acknowledgement",
  from: "thecircle@wildcraft.com",
  subject: "Welcome to the Wildcraft Circle!",
  message: "",
};
const MESSAGE_TRIGGER_PARAM3 = {
  templateId: "wildcraft_circle_acknowledgement_sms",
  message: "Welcome to the Wildcraft Circle!",
};
const CIRCLE_OTP_HEADING = "Join The Circle";
const CIRCLE_OTP_SUBHEADING = "OTP has been sent to ";

const GENERIC_FORM_NAME = "CIRCLE_PROGRAM";
const REMARKS_FORM_TITLE = "Join the Circle";
const REMARKS_FORM_SUBTITLE = "Register Now!";
const REMARKS_FORM_BUTTON_TEXT = "Submit";
const REMARKS_FORM_RECIEVE_UPDATE_TEXT =
  "I agree to receive updates via WhatsApp, Email and SMS.";
const REMARKS_FORM_WHATSAPP_NUMBER_TEXT = "Same as Mobile number";
const REMARKS_FORM_WHATSAPP_NUMBER_BOOL = true;
const NAME_TITLES = '["Mr.","Mrs.","Master","Miss"]';

const CIRCLE_PROGRAM = {
  CIRCLE_DETAILS_SUBTILE1,
  CIRCLE_DETAILS_BRIEF1,
  CIRCLE_DETAILS_BRIEF2,
  CIRCLE_DETAILS_SUBTILE2,
  CIRCLE_DETAILS_LIST,
  CIRCLE_DETAILS_CONCLUSION,
  MESSAGE_TRIGGER_PARAM1,
  MESSAGE_TRIGGER_PARAM2,
  MESSAGE_TRIGGER_PARAM3,
  REMARKS_FORM_TITLE,
  REMARKS_FORM_SUBTITLE,
  REMARKS_FORM_BUTTON_TEXT,
  REMARKS_FORM_RECIEVE_UPDATE_TEXT,
  REMARKS_FORM_WHATSAPP_NUMBER_TEXT,
  REMARKS_FORM_WHATSAPP_NUMBER_BOOL,
  CIRCLE_DETAILS_BRIEF3,
  CIRCLE_DETAILS_BRIEF4,
  GENERIC_FORM_NAME,
  CIRCLE_OTP_HEADING,
  CIRCLE_OTP_SUBHEADING,
  NAME_TITLES,
};

export default CIRCLE_PROGRAM;
